module.exports = __webpack_public_path__ + "img/Cocaine (COC).f51766cf.png";